import { render, staticRenderFns } from "./video-information.vue?vue&type=template&id=8a043a08&"
import script from "./video-information.vue?vue&type=script&lang=js&"
export * from "./video-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports